/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useFormContext } from "react-hook-form";

import ValidationErrorText from "components/ui/validation/ValidationErrorText";

// CSS読み込み
import {
  checkInput,
  inputArea_check,
  inputArea_check_error,
} from "assets/css/stylesCss";

/**
 * チェックボックス
 * @param {String} id 
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} value value属性用初期値
 * @param {String} children 子要素
 * @param {Object} rules バリデーション設定オブジェクト
 */
const CheckBox = memo(({ id, name, value, children, rules }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext();

  return (
    <>
      <label
        css={errors[name] ? inputArea_check_error : inputArea_check}
        htmlFor={id}
      >
        <input
          css={checkInput}
          {...register(name, {
            ...rules,
            onChange: () =>
              // mode設定(onBlur)によりタップ後フォーカスを外すまで反応しないため、例外的にリアルタイムでバリデーションを実行
              setValue(name, getValues(name), {
                shouldValidate: true,
              }),
          })}
          type="checkbox"
          id={id}
          name={name}
          value={value}
        />
        {children}
      </label>

      {/* エラーメッセージ **/}
      {errors[name] && (
        <ValidationErrorText>{errors[name].message}</ValidationErrorText>
      )}
    </>
  );
});

export default CheckBox;
